export default "__VITE_ASSET__e456d9df__"